import {
    Box, Button, Chip, Dialog, DialogContent, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Stack, TextField, Typography,CircularProgress,
    Tooltip,
    ToggleButton,
    ToggleButtonGroup,
    Breadcrumbs,
} from '@mui/material';
import React, { useState, useEffect, useMemo ,useRef, useCallback} from "react";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";
import ChatIcon from '@mui/icons-material/Chat';
import Helmet from 'react-helmet';
import { useFitHeight } from '../../../_metronic/layout/Layout';
import { Portlet, PortletBody, PortletHeader, PortletHeaderToolbar } from '../../partials/content/Portlet';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import SendIcon from '@mui/icons-material/Send';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import { ContractsBreadCrumb } from './ContractsBreadCrumb';
import { useData } from '@pure-ptr/react';
import { ContractInfo } from '../../store/api/ai-api';
import TypingDots from '../../common/TypingDots';
import { get,tiny } from '../../store/actions/contracts';
import { useDispatch, useSelector } from 'react-redux';
import { errorToastify } from '../../util/toast';
import { RootState } from '../../store/reducers';
import { Loadable } from '../../common';
import makeStyles from '@mui/styles/makeStyles';
import { getEAPGCreditUsage } from '../../store/api/eapg';
import {useMarkdown} from '../../../hooks/ReactMarkdown';
import { parseStreamResponseBasedOnReader, stripAiMarkers } from '../../util';
import SvgIcon from '../../svg/SvgIcon';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import { ProgressBar } from 'react-bootstrap';
import { selectSessionUserClientId } from '../../store/selectors/session';
import { generateErrorToaster } from '../ClaimAnalysisPage/ClaimAnalysisPage';
import FollowUpList from './FolloupQuestions';
import { checkIfFHIRConfigExists } from '../../store/api/clients';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import PatientDetail from '../ClaimAnalysisPage/ClaimViewPage/PatientDetails/PatientDetails';
import DeleteIcon from '@mui/icons-material/Delete';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { getDocument } from '../../store/api/contracts';
import CloseIcon from '@mui/icons-material/Close';
import { WindowOutlined } from '@mui/icons-material';

const useStyles = makeStyles(theme => ({
    chatbot: {
        flexGrow: 1,
        overflowY: 'auto'
    },
    contractStack: {
        marginBottom: theme.spacing(1),
    },
    contractLabel: {
        fontWeight: "bold",
        display: "grid",
        alignItems: "center"
    },
    chip: {
        marginRight: theme.spacing(1),
    },
    botContainer: {
        maxWidth: '80%',
        alignSelf: 'flex-start',
        display: "flex",
        columnGap: "10px"
    },
    botIcon: {
        height: "40px",
        width: "40px",
        display: "grid",
        alignContent: 'center',
        justifyContent: 'center',
        borderRadius: "8px",
        flex: '0 0 40px'
    },
    botText: {
        backgroundColor: '#f0fff0',
        padding: '8px',
        borderRadius: '8px',
        fontWeight: 400
    },
    messageBox: {
        maxWidth: '90%',
        padding: '8px',
        borderRadius: '8px',
        marginBottom: theme.spacing(1),
        whiteSpace: 'pre-line',
        fontWeight:400,
        display: "flex",
        gap: "7px",
        flexDirection: "column"
    },
    assistant: {
        backgroundColor: "#f0fff0",
        // color: "white",
        fontWeight:400,
        alignSelf: "flex-start"
    },
    user: {
        backgroundColor: "#f0f0ff",
        color: "inherit",
        alignSelf: "flex-end"
    },
    div: {
        backgroundColor: "#fff",
        padding: '15px 13px',
        margin: '-5px -10px 10px -10px'
    },
    scrollToBottomButton: {
        position: "absolute",
        top: 180,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
    },
    link: {
        textDecoration: 'underline',
        fontSize: '14px',
    }
}));

export const AiChatDialog = ({ selected, onClose }) =>

        <DialogContent sx={{ padding: 0,display:"flex" }}>
            <AiChatPage selected={selected} defaultTitle="" height="100%" onClose={onClose}/>
        </DialogContent>


const AiChat = ({ 
    selected, height = undefined, title, setTitle, sessionId, setSessionId, messages, setMessages, 
    setPreviousTitle, CHAT_TYPE, claimNumber, reloadChat, isEditingTitle, newMessageBtnRef, 
    chatBotContainer, currentTypedUserMessage, setCurrentTypedUserMessage, credits, isFetchingCredits, 
    setRefetchCredits, selectedClaimIds = [], totalClaimsCount = 0, externalMessage = '', 
    onMessageSent = null, onFiltersUpdate = null, disableAutoFocus = false, isSidebarMode = false, 
    enableResponseFilters = true, newChatbutton = { enable: true, text: 'New Chat' }, 
    enableIconTitle = false, queryContractId = null, querySessionId = null, preAiModeFilters = null, 
    enableFeedback, significanceFlag = false, confidenceScoreFlag = false, reasoningModel = null, quickModel = null,
    availableModels = { explanatory: [], reasoning: [] }
}) => {
    const history = useHistory();
    const [supplementaryReferences, setSupplementaryReferences] = useState<any>(null);
    const [isSupplementaryRefsDismissed, setIsSupplementaryRefsDismissed] = useState(false);
    const [sendMessagePayload, setSendMessagePayload] = useState<any>({});
    const externalMessageProcessedRef = useRef('');
    const ContractAPIS = new ContractInfo();
    const { contractId: routeContractId, sessionId: urlSessionId }: any = useParams();
    // Use query params if available (sidebar mode), otherwise use route params
    // queryContractId and querySessionId come as props from outer component
    const contractId = (queryContractId !== null && queryContractId !== undefined) ? queryContractId : routeContractId;
    const resolvedSessionId = (querySessionId !== null && querySessionId !== undefined) ? querySessionId : urlSessionId;
    
    const dispatch = useDispatch();
    const clientId = useSelector<RootState>((state) => state.dashboards.selectedClient);
    const contractName: any = useSelector<RootState>((state) => state?.contracts?.data[0]?.name);
    const isFetchingContracts: any = useSelector<RootState>((state) => state?.contracts?.get?.pending);
    const isFetchingAllContracts: any = useSelector<RootState>((state) => state?.contracts?.getTiny?.pending);
    const clientHaveAIAccess = useSelector<RootState>((state) => state.clients.hasAIAccess)
    const haveClaimAIAccess = useSelector<RootState>((state) => state.clients.hasClaimChatBotAccess)
    const hasClaimSemanticSearchAccess = useSelector<RootState>((state) => state.clients.hasClaimSemanticSearchAccess);
    
    const tinyContracts:any = useSelector<RootState>((state) => state?.contracts?.tiny)
    const [followUpQuestions, setFollowUpQuestions] = useState<string[]>([])
    const inputElementRef = useRef<HTMLInputElement | null>(null);

    // State for stop response and retry logic
    const [isStreaming, setIsStreaming] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const abortControllerRef = useRef<AbortController | null>(null);

    // ─── Async Guardrail Refs ───────────────────────────────────────────────────
    const guardrailBlockedRef = useRef<boolean>(false);        // true → guardrail said "blocked"
    const guardrailResolvedRef = useRef<boolean>(false);       // true → guardrail has responded
    const guardrailHandledRef = useRef<boolean>(false);        // true → UI already updated for current block
    const guardrailSafeResponseRef = useRef<string>('');       // safe_response text from guardrail
    // Info about the current user message, used when blocking is applied after stream already started
    const pendingBlockedUserMsgRef = useRef<{ id: string; body: string } | null>(null);
    // Holds the session ID available when the guardrail resolves (needed for stopResponse call)
    const streamingSessionIdRef = useRef<number | null>(null);
    
    // Track retry attempts and failed messages
    const [messageRetryCount, setMessageRetryCount] = useState<Record<string, number>>({});
    const [failedMessages, setFailedMessages] = useState<Set<string>>(new Set());
    
    // Track feedback state for each message
    const [messageFeedback, setMessageFeedback] = useState<Record<string, 'like' | 'dislike' | null>>({});
    const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
    const [feedbackMessageId, setFeedbackMessageId] = useState<string | null>(null);
    const [feedbackText, setFeedbackText] = useState('');
    const [sprinklingMessages, setSprinklingMessages] = useState<Set<string>>(new Set());
    
    // Feedback settings configuration
    const feedbackSettings = {
        submitted_feedback_can_reset: true // Set to false to prevent users from changing feedback after submission
    };

    const getSupplementaryDocLabel = useCallback((doc: any) => {
        if (doc?.document_name) return doc.document_name;
        if (doc?.documentName) return doc.documentName;
        const s3Key = doc?.s3_key || '';
        const fileNameWithPrefix = s3Key.split('/').pop() || 'Document';
        const underscoreIndex = fileNameWithPrefix.indexOf('_');
        if (underscoreIndex >= 0 && underscoreIndex < fileNameWithPrefix.length - 1) {
            return fileNameWithPrefix.substring(underscoreIndex + 1);
        }
        return fileNameWithPrefix;
    }, []);

    const openSupplementaryDocumentPreview = useCallback(async (doc: any) => {
        const metadataId = doc?.document_metadata_id || doc?.document_id;
        if (!metadataId) {
            errorToastify("Unable to open document preview");
            return;
        }

        try {
            const fileBlob = await getDocument(metadataId);
            const documentName = getSupplementaryDocLabel(doc);
            let documentType = 'application/pdf';
            if (doc?.metadata) {
                try {
                    const parsedMetadata = typeof doc.metadata === 'string' ? JSON.parse(doc.metadata) : doc.metadata;
                    if (parsedMetadata?.type) {
                        documentType = parsedMetadata.type;
                    }
                } catch {
                    // Keep default document type when metadata parsing fails
                }
            }
            const file = new File([fileBlob], documentName, { type: documentType });
            const browserWindow = window.open();
            if (browserWindow) {
                browserWindow.location.href = window.URL.createObjectURL(file);
            }
        } catch (error) {
            errorToastify("Failed to load document preview");
        }
    }, [getSupplementaryDocLabel]);
    
    
    // Simple fallback ID generator (only used if stream doesn't provide ID)
    const generateFallbackMessageId = useCallback(() => {
        return `msg-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    }, []);
    
    // Ensure all messages have IDs - run whenever messages change
    // Only add IDs to non-loading messages that don't already have one
    useEffect(() => {
        setMessages(prev => {
            let hasChanges = false;
            const updated = prev.map(msg => {
                // Skip loading messages - they'll get IDs from stream or when loading completes
                if (msg.loading || msg.loadingSpin || msg.stream) {
                    return msg;
                }
                
                // Add fallback ID only if missing (stream should provide ID for assistant messages)
                if (!msg.id) {
                    hasChanges = true;
                    return { ...msg, id: generateFallbackMessageId() };
                }
                return msg;
            });
            return hasChanges ? updated : prev;
        });
    }, [messages, generateFallbackMessageId]);


    // Quick Response ('explanatory') is the default; user may explicitly switch to Reasoning.
    // Auto mode has been removed.
    const [chatActions, setChatActions] = useState({
        selected: 'explanatory'
    });
    
    const classes = useStyles();
    const bottomRef = useRef<HTMLDivElement>(null);

    const [isManuallyScrolling, setIsManuallyScrolling] = useState(false);
    const [newMessageReceived, setNewMessageReceived] = useState(false);
    const [lastMessageId, setLastMessageId] = useState(null);

    useEffect(() => {
        if (bottomRef.current) {
            // * Scroll to bottom only if not manually scrolling
            // * This prevents auto-scrolling when user is manually scrolling up
            if (!isManuallyScrolling) {
                bottomRef.current.scrollIntoView({ behavior: "smooth" });
            } else {
                setLastMessageId(null);
            }
        }
    }, [messages,isManuallyScrolling, lastMessageId]);


    useEffect(() => {
        if (selected?.length > 0  || contractId == 0 || !contractId) return;
        // Only fetch if we don't have this contract data yet or if it's not currently fetching
        if (CHAT_TYPE !== "claim" && CHAT_TYPE !== "claim_analysis") { 
            dispatch(get(contractId)) 
        }
    }, [contractId, CHAT_TYPE, dispatch]); // Removed 'selected' and 'contractName' from deps to avoid loop

    const parseString = (str) => {
        try {
            return JSON.parse(str);
        } catch (e) {
            return str
        }
    }

    // Create new chat session when sendMessagePayload changes
    const {
        isPending: isCreatingNewSession,
        error: creatingSessionError
    } = useData(async () => {
        if (Object.keys(sendMessagePayload).length <= 0) return;
        const sessionResponse = await ContractAPIS.createNewChatSession(sendMessagePayload);
        setSessionId({
            sessionId: sessionResponse?.id,
            messages: { body: sendMessagePayload?.messages[0]?.body },
            addMessage: true
        });
        setTitle(parseString(sessionResponse?.title));
        setPreviousTitle(parseString(sessionResponse?.title));
        return sessionResponse;
    }, [sendMessagePayload,CHAT_TYPE]);

    // Add user message and fetch all session messages when sessionId changes
    const { error: addMessageError, isPending: fetchingMessages } = useData(async () => {
        if (Object.keys(sessionId).length < 2) return;
        // * User send message
        if (sessionId.addMessage) {
            const userMsg = sessionId.messages?.body;

            // Track current session so guardrail callback can call stopResponse
            streamingSessionIdRef.current = sessionId.sessionId;

            // Create AbortController for this request
            abortControllerRef.current = new AbortController();
            setIsStreaming(true);
            setIsSending(false); // Message sent, now streaming response

            try {
                // Build stream payload — route the selected model(s) to the correct field(s).
                // If no override is set, omit both fields so the backend uses its defaults.
                const streamPayload: any = {
                    body: userMsg,
                };
                
                // If user selected specific intent, send it. If 'auto', omit to let backend decide.
                if (chatActions.selected !== 'auto') {
                    streamPayload.intent_type = chatActions.selected;
                }

                if (reasoningModel?.id) {
                    streamPayload.reasoning_model = reasoningModel.id;
                }
                if (quickModel?.id) {
                    streamPayload.explanatory_model = quickModel.id;
                }

                const response = await ContractAPIS.addUserMessageToSessionStreamed(
                    sessionId.sessionId,
                    streamPayload,
                    sessionId.isRetry || false // Pass retry flag
                );
                const reader = response.body?.getReader();
                const decoder = new TextDecoder("utf-8");
                let fullAssistantText = "";

                // ── Async Guardrail Integration ──────────────────────────────────────
                // Poll guardrailBlockedRef on each chunk. If blocked mid-stream:
                //   1. Call stopResponse API to cancel the backend stream.
                //   2. Remove the assistant placeholder and mark the user message as blocked.
                const checkGuardrailMidStream = async () => {
                    // Wait until guardrail has responded
                    while (!guardrailResolvedRef.current) {
                        await new Promise(r => setTimeout(r, 50));
                    }
                        if (guardrailBlockedRef.current) {
                            // Prevent duplicate handling if Case 1 already did it
                            if (guardrailHandledRef.current) return true;
                            guardrailHandledRef.current = true;

                            // ── Step 0: Cancel the reader immediately ───────────────────
                            if (reader) {
                                try {
                                    await reader.cancel();
                                } catch (e) {
                                    console.warn("Reader cancel failed:", e);
                                }
                            }
                            // ── Step 1: Stop the backend stream and WAIT for confirmation ──
                            // Must await so the agent response is fully cancelled before we
                            // remove it from the UI. Removing the message before the stream
                            // stops could cause a race where new tokens still arrive after
                            // we've cleaned up.
                            if (sessionId?.sessionId) {
                                try {
                                    await ContractAPIS.stopResponse(sessionId.sessionId, true);
                                } catch {
                                    // Swallow stop errors — stream may have already ended naturally.
                                    // UI cleanup proceeds regardless.
                                }
                            }

                            // ── Step 2: Update streaming state ──────────────────────────────
                            setIsStreaming(false);

                            // ── Step 3: Remove agent message, apply blocking UI ─────────────
                            // Only after the stop is confirmed do we touch the message list.
                            const GUARDRAIL_BLOCKED_MESSAGE = "We're Sorry, This request cannot be processed due to privacy and compliance rules. You may rephrase with a different question.";
                            const safeMsg = GUARDRAIL_BLOCKED_MESSAGE;
                            const userMsgInfo = pendingBlockedUserMsgRef.current;
                            setMessages(prev => {
                                // Remove ANY assistant message that is a reply to the CURRENT blocked user message.
                                // This is more aggressive than just filtering by loading/stream status.
                                const withoutAssistantPlaceholder = prev.filter(
                                    m => !(m.createdBy === 'assistant' && (m.replyToUserMessageId === userMsgInfo?.id || m.loading || m.stream || m.loadingSpin || m.status === 'streaming'))
                                );
                                // Mark the user message with guardRailsPass: false (triggers blocking UI)
                                return withoutAssistantPlaceholder.map(m => {
                                    if (userMsgInfo && m.id === userMsgInfo.id) {
                                        return { ...m, guardRailsPass: false };
                                    }
                                    return m;
                                }).concat([
                                    // Append the guardrail safe-response as the assistant reply
                                    {
                                        id: generateFallbackMessageId(),
                                        body: safeMsg,
                                        createdBy: 'assistant',
                                        replyToUserMessageId: userMsgInfo?.id,
                                        status: 'complete',
                                        createdAt: 'Now',
                                        guardRailsPass: false
                                    }
                                ]);
                            });
                            return true; // Signal: stream was blocked
                        }
                        return false; // Signal: stream is allowed
                    };

                    // Run guardrail check and stream reading in parallel
                    const [wasBlocked] = await Promise.all([
                        checkGuardrailMidStream(),
                        (async () => {
                            // Only parse stream if guardrail not already blocked
                            // (checkGuardrailMidStream resolves quickly if guardrail already responded)
                            const { followUpQuestions: allFollowUpQuestions } = await parseStreamResponseBasedOnReader(
                                reader,
                                decoder,
                                fullAssistantText,
                                setMessages,
                                sessionId,
                                 null,
                                null,
                                null,
                                () => guardrailBlockedRef.current,
                                (data) => {
                                    setSupplementaryReferences(data);
                                    setIsSupplementaryRefsDismissed(false);
                                }
                            );
                            if (!guardrailBlockedRef.current) {
                                setFollowUpQuestions(allFollowUpQuestions);
                            }
                        })()
                    ]);

                // If blocked mid-stream, skip finalising the streamed message
                if (!wasBlocked) {
                    setMessages((prev) => {
                        const updated = [...prev];
                        const lastAssistantIndex = updated.findIndex(
                            (m) => (m?.stream) && m.createdBy === "assistant"
                        );
                        if (lastAssistantIndex !== -1) {
                            updated[lastAssistantIndex] = {
                               ...updated[lastAssistantIndex],
                                loading: false,
                                loadingSpin: false,
                                stream: undefined,
                                status: 'complete'
                            };
                        }
                        return updated;
                    });
                }
            } catch (error) {
                // If the error is due to a guardrail block, the UI is already handled — skip
                if (guardrailBlockedRef.current) {
                    setIsStreaming(false);
                    abortControllerRef.current = null;
                    return;
                }
                console.error('Stream API error:', error);
                // Mark the assistant message as failed
                setMessages((prev) => {
                    const updated = [...prev];
                    const lastAssistantIndex = updated.findIndex(
                        (m) => (m?.loading || m?.stream || m?.loadingSpin) && m.createdBy === "assistant"
                    );
                    if (lastAssistantIndex !== -1) {
                        // Preserve existing ID if it exists, or create new one only if needed
                        const existingId = updated[lastAssistantIndex]?.id;
                        const messageId = existingId ?? generateFallbackMessageId();
                        
                        const failedMsg = {
                            ...updated[lastAssistantIndex],
                            loading: false,
                            stream: undefined,
                            loadingSpin: false,
                            status: 'failed',
                            failed: true,
                            body: "Failed to load response. Please try again.",
                            id: messageId,
                            createdAt: new Date()
                        };
                        updated[lastAssistantIndex] = failedMsg;
                        
                        // Add to failed messages set
                        setFailedMessages(prev => new Set(prev).add(messageId));
                    }
                    return updated;
                });
            }

        // Reset streaming state after completion
        setIsStreaming(false);
        abortControllerRef.current = null;
        streamingSessionIdRef.current = null;

        }

        const lastMessageId = messages?.length ? messages[messages.length - 1]?.id : null;
       setSessionId({ sessionId: sessionId.sessionId });

        // * Init page
        if (!sessionId?.addMessage) {
            // No Streaming, Fetch all messages Initially
            const allSessionMessage = await ContractAPIS.getAllSessionMessages(
                sessionId.sessionId,
                lastMessageId
            );

            const container = chatBotContainer.current.closest(
                ".chatbot-container-scrollbar"
            );
            
            if(!allSessionMessage[0]?.[1]?.more_messages) {
                localStorage.setItem('removeScrollEvent',"true")
                container.removeEventListener('scroll', handleScroll);
            } else {
                localStorage.removeItem('removeScrollEvent')
                container.addEventListener('scroll', handleScroll)
            }

            // not remove first summary message (only if it exists and has content)
            
            setMessages((prev)=>{
                    const firstMessage = prev[0];
                    const hasValidFirstMessage = firstMessage && firstMessage.body && firstMessage.body.trim() !== '';
                    
                    const historyMessages = allSessionMessage[0]?.[1]?.messages?.reverse() || [];
                    
                    // Extract the last assistant message with supp_ref to set global state
                    // and filter supp_ref from older messages as requested
                    let lastSuppRef = null;
                    for (let i = historyMessages.length - 1; i >= 0; i--) {
                        const msg = historyMessages[i];
                        if (msg.createdBy === 'assistant' && msg.supp_ref) {
                            if (!lastSuppRef) {
                                lastSuppRef = msg.supp_ref;
                            } else {
                                // Only keep the last one, filter others
                                delete msg.supp_ref;
                            }
                        }
                    }

                    if (lastSuppRef) {
                        setSupplementaryReferences(lastSuppRef);
                        setIsSupplementaryRefsDismissed(false);
                    }
                    
                    return [
                        ...(hasValidFirstMessage ? [firstMessage] : []),
                        ...historyMessages
                    ];
                })
            
            // Populate feedback state from API response
            const feedbackMap: Record<string, 'like' | 'dislike' | null> = {};
            (allSessionMessage[0][1]?.messages || []).forEach((msg: any) => {
                if (msg.id && msg.feedback_status) {
                    // Map backend feedback status to frontend format
                    if (msg.feedback_status === 'THUMBS_UP') {
                        feedbackMap[msg.id] = 'like';
                    } else if (msg.feedback_status === 'THUMBS_DOWN') {
                        feedbackMap[msg.id] = 'dislike';
                    }
                }
            });
            
            // Update feedback state with loaded feedback
            if (Object.keys(feedbackMap).length > 0) {
                setMessageFeedback(prev => ({
                    ...prev,
                    ...feedbackMap
                }));
            }
            
            localStorage.removeItem(
                `lastMessageId-${sessionId.sessionId}`
            );
        }
        
        return
    }, [sessionId,CHAT_TYPE]);

    
    const { data: sessionDetails, isPending: isFetchingSessionDetails }: any =
        useData(
            async (abort) => {
                if (!resolvedSessionId || resolvedSessionId==0 || tinyContracts?.length == 0) return;

                const sessionDetails = await ContractAPIS.getSessionDetails(
                    resolvedSessionId
                );

                const parsedContracts = sessionDetails?.contractIds?.map(
                    (item) =>
                        tinyContracts?.find((contract) => contract?.id === item)
                );
                setTitle(parseString(sessionDetails?.title) || "Untitled");
                setPreviousTitle(parseString(sessionDetails?.title) || "Untitled");
                return { contractIds: parsedContracts ,isReadOnly:sessionDetails?.is_readonly};
            },
            [tinyContracts, resolvedSessionId]
        );

    const chatBufferValue = 5; // Buffer to prevent hitting the limit exactly
    const canUseAI = useCallback(()=> {
        const aiCredits = credits || {};
        return (
            aiCredits?.totalLimit &&
            aiCredits?.usedCredits + chatBufferValue < aiCredits?.totalLimit
        );
    },[credits, messages]);

    const haveAIAccess = useMemo(() => {
        if(CHAT_TYPE === 'claim') {
           return haveClaimAIAccess && canUseAI();
        } else if (CHAT_TYPE === 'claim_analysis') {
            return hasClaimSemanticSearchAccess && canUseAI();
        } else {
            return clientHaveAIAccess && canUseAI();
        }
    }, [clientHaveAIAccess, canUseAI, CHAT_TYPE, haveClaimAIAccess, hasClaimSemanticSearchAccess]);
    // Reset messages if session creation fails
    useEffect(() => {
        if (creatingSessionError?.payload || addMessageError?.payload) {
            errorToastify("Something Went Wrong !! Please Contact Admin")
            setMessages([...(messages?.filter((item) => !item?.loading) || [])])
        }
    }, [creatingSessionError, addMessageError]);

    useEffect(() => {
        if (!resolvedSessionId || resolvedSessionId==0) return

        if (tinyContracts?.length == 0) {
            dispatch(tiny());
        }
        setSessionId({ sessionId: resolvedSessionId, addMessage: false })
    }, [resolvedSessionId, dispatch]);

    // TODO: If we open claim chat, we need to trigger an API

    // Helper function to find the previous user message for a given index
    const findPreviousUserMessage = useCallback((currentIndex: number) => {
        for (let i = currentIndex - 1; i >= 0; i--) {
            const msg = messages[i];
            if (msg?.sentBy === "current user" || msg?.createdBy === "user") {
                return msg;
            }
        }
        return null;
    }, [messages]);

    // Pre-compute retry data for each message to avoid expensive operations in JSX
    const messageRetryData = useMemo(() => {
        const retryMap = new Map();
        messages.forEach((item, idx) => {
            if (item?.createdBy === "assistant" && !item?.loadingSpin && !item?.loading && !item?.summary && item?.failed) {
                const userMsg = findPreviousUserMessage(idx);
                const retryCount = messageRetryCount[item?.id] || 0;
                const canRetry = retryCount < 3;
                
                retryMap.set(idx, {
                    userMsg,
                    retryCount,
                    canRetry,
                    shouldShow: !!userMsg
                });
            }
        });
        return retryMap;
    }, [messages, messageRetryCount, findPreviousUserMessage]);

    // Memoize messages for rendering
    const renderedMessages = useMemo(
        () =>
            messages.map((item, idx) => {

                // If guardrail failed → override body with custom message
                                const isBlocked = item?.guardRailsPass === false;
                
                                const displayBody = (isBlocked && item?.createdBy === 'user')
                                    ? "_**Content Removed**_"
                                    : item?.body;
                
                                return <>
                                    {item?.loading ? (
                                        <Box key={idx} sx={{ padding: "8px", width: "fit-content" }}>
                                            <TypingDots />
                                        </Box>
                                    ) : (
                                        <>
                                        
                                        <Box
                                            key={idx}
                                            className={`${classes.messageBox} ${
                                                item?.createdBy === "assistant"
                                                    ? classes.assistant
                                                    : classes.user
                                            }`}
                                            
                                        >
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    display: "block",
                                                    textAlign: "right",
                                                    opacity: 0.7,
                                                }}

                                            >
                                                {item?.createdAt === "Now"
                                                    ? "Now"
                                                    : item?.createdAt
                                                    ? new Date(item.createdAt).toLocaleString()
                                                    : new Date().toLocaleString()}
                                            </Typography>
                
                                            {item?.loadingSpin ? (
                                                <Stack direction="row" key={idx} alignItems="center" gap={2}>
                                                    <div>{displayBody}</div>
                                                    <div>
                                                        <SvgIcon className="spin" id="chat-loader" />
                                                    </div>
                                                </Stack>
                                            ) : (
                                                useMarkdown({
                                                    rawMarkdown: displayBody || "",
                                                    isStreaming: item?.stream,
                                                })
                                            )}
                                            
                                            
                                            
                                        </Box>

                                        
                                        {/* Action button wrapper - Only show for assistant messages when there's content */}
                                        {(
                                            // Show for completed assistant messages (feedback icons) - only if feedback is enabled
                                            (enableFeedback && item?.createdBy === "assistant" && !item?.loading && !item?.loadingSpin && !item?.failed && !item?.summary && idx !== 0 && (item?.status === 'complete' || !item?.status) && item?.guardRailsPass !== false) ||
                                            // OR show for failed assistant messages (retry button)
                                            (messageRetryData.has(idx) && messageRetryData.get(idx).shouldShow)
                                        ) && (
                                            <div className="action-button-wrapper">
                                                {/* Feedback Icons - Only show for assistant messages that are complete and not failed */}
                                                {enableFeedback && item?.createdBy === "assistant" && !item?.loading && !item?.loadingSpin && !item?.failed && !item?.summary && idx !== 0 && (item?.status === 'complete' || !item?.status) && item?.guardRailsPass !== false && (
                                                    <>
                                                    <Box 
                                                        sx={{ 
                                                            display: 'flex',
                                                            gap: 0.5,
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        {/* Like Button - Show when: no feedback OR liked */}
                                                        {(!messageFeedback[item.id || `msg-${idx}`] || messageFeedback[item.id || `msg-${idx}`] === 'like') && (
                                                            <div className="like-sprinkle-container">
                                                                <Tooltip title={messageFeedback[item.id || `msg-${idx}`] === 'like' ? (feedbackSettings.submitted_feedback_can_reset ? "Remove like" : "Like") : "Like this response"} placement="top">
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => handleLikeFeedback(item.id || `msg-${idx}`)}
                                                                        sx={{ 
                                                                            padding: 0.5,
                                                                            color: messageFeedback[item.id || `msg-${idx}`] === 'like' ? '#4caf50' : 'inherit'
                                                                        }}
                                                                    >
                                                                        {messageFeedback[item.id || `msg-${idx}`] === 'like' ? (
                                                                            <ThumbUpIcon fontSize="small" />
                                                                        ) : (
                                                                            <ThumbUpOutlinedIcon fontSize="small" />
                                                                        )}
                                                                    </IconButton>
                                                                </Tooltip>
                                                                
                                                                {/* Sprinkle particles */}
                                                                {sprinklingMessages.has(item.id || `msg-${idx}`) && (
                                                                    <>
                                                                        {
                                                                            Array.from({ length: 12 }, (_, i) => i + 1).map((particleIndex) => (
                                                                                <div className={`sprinkle-particle particle-${particleIndex}`}></div>
                                                                            ))
                                                                        }
                                                                    </>
                                                                )}
                                                            </div>
                                                        )}

                                                        {/* Dislike Button - Show when: no feedback OR disliked */}
                                                        {(!messageFeedback[item.id || `msg-${idx}`] || messageFeedback[item.id || `msg-${idx}`] === 'dislike') && (
                                                            <Tooltip title={messageFeedback[item.id || `msg-${idx}`] === 'dislike' ? (feedbackSettings.submitted_feedback_can_reset ? "Remove dislike" : "Dislike") : "Dislike this response"} placement="top">
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => handleDislikeFeedback(item.id || `msg-${idx}`)}
                                                                    sx={{ 
                                                                        padding: 0.5,
                                                                        color: messageFeedback[item.id || `msg-${idx}`] === 'dislike' ? '#f44336' : 'inherit'
                                                                    }}
                                                                >
                                                                    {messageFeedback[item.id || `msg-${idx}`] === 'dislike' ? (
                                                                        <ThumbDownIcon fontSize="small" />
                                                                    ) : (
                                                                        <ThumbDownOutlinedIcon fontSize="small" />
                                                                    )}
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                    </Box>
                                                    </>
                                                )}
                                                
                                                {/* Retry button below failed assistant messages only */}
                                                {messageRetryData.has(idx) && messageRetryData.get(idx).shouldShow && (
                                                    <Box 
                                                        sx={{ 
                                                            backgroundColor: 'transparent !important',
                                                            display: 'flex',
                                                            justifyContent: 'flex-start',
                                                            gap: 1,
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <Tooltip title={messageRetryData.get(idx).canRetry ? "Retry this response" : "Max retries reached"} placement="top"> 
                                                            <IconButton
                                                                size="small"
                                                                disableRipple
                                                                disabled={!messageRetryData.get(idx).canRetry}
                                                                onClick={() => {
                                                                    // Use the new unified retry handler - no index searching!
                                                                    if (item?.id) {
                                                                        handleRetry(item.id);
                                                                    }
                                                                }}
                                                                sx={{ padding: 0.5, opacity: messageRetryData.get(idx).canRetry ? 1 : 0.5 }}
                                                            >
                                                                <RefreshIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                )}
                                            </div>
                                        )}
                
                                        
                
                                        {isBlocked && item?.createdBy === 'user' && (
                                            <Typography key={idx} className={` ${
                                                item?.createdBy === "assistant"
                                                    ? classes.assistant
                                                    : classes.user
                                            }`} variant="caption" sx={{ color: "#dc3545 !important", backgroundColor:'transparent !important' }}>
                                                This content may violate our <a href="https://slicedhealth.com/terms/" target="_blank" rel="noopener noreferrer" style={{color: 'currentcolor', textDecoration: 'underline'}}>Terms of Use</a> or <a href="https://slicedhealth.com/privacy/" target="_blank" rel="noopener noreferrer" style={{color: 'currentcolor', textDecoration: 'underline'}}>Usage Policy</a>
                                            </Typography>
                                        )}
                                        
                                        {/* Show "Stopped by user" message for stopped responses */}
                                        {item?.stoppedByUser && item?.createdBy === "assistant" && (
                                            <Typography className={` ${
                                                item?.createdBy === "assistant"
                                                    ? classes.assistant
                                                    : classes.user
                                            }`} variant="caption" sx={{ color: "#dc3545 !important", backgroundColor:'transparent !important', fontStyle: 'italic' }}>
                                                Stopped by user
                                            </Typography>
                                        )}
                                        </>
                                    )}
                                    </>
            }),
        [messages, classes.messageBox, classes.assistant, classes.user, messageRetryData, messageFeedback]
    );

    const handleStopResponse = async () => {
        try {
            // Call stop response API without message ID
            if (sessionId?.sessionId) {
                const response = await ContractAPIS.stopResponse(sessionId?.sessionId);
                
                // If stop was successful, remove loader and streaming states
                if (response?.status === 'stopped' || response?.status === 'success') {
                    setIsStreaming(false);
                    setIsSending(false);
                    
                    // Remove loading/streaming indicators from messages and mark as stopped
                    setMessages(prev => {
                        const updated = [...prev];
                        const streamingIndex = updated.findIndex(
                            m => (m?.loading || m?.stream || m?.loadingSpin) && m.createdBy === "assistant"
                        );
                        if (streamingIndex !== -1) {
                            updated[streamingIndex] = {
                                ...updated[streamingIndex],
                                loading: false,
                                stream: undefined,
                                loadingSpin: false,
                                stoppedByUser: true // Mark as stopped by user
                            };
                        }
                        return updated;
                    });
                }
            }
        } catch (error) {
            console.error('Error stopping response:', error);
            // Even on error, try to stop the streaming state
            setIsStreaming(false);
            setIsSending(false);
        }
    };

    // Unified retry handler using message relationships (no index searching!)
    const handleRetry = useCallback((assistantMessageId: string) => {
        // Find the assistant message by its ID
        const assistantMsg = messages.find(m => m.id === assistantMessageId);
        if (!assistantMsg || !assistantMsg.replyToUserMessageId) {
            // Cannot retry: assistant message not found or missing replyToUserMessageId
            return;
        }

        // Find the user message it's replying to
        const userMsg = messages.find(m => m.id === assistantMsg.replyToUserMessageId);
        if (!userMsg || !userMsg.body) {
            // 'Cannot retry: user message not found
            return;
        }

        // Check retry count
        const retryCount = messageRetryCount[assistantMessageId] || 0;
        if (retryCount >= 3) {
            errorToastify("Please try again later or contact administrator");
            // Remove from failed messages
            setFailedMessages(prev => {
                const newSet = new Set(prev);
                newSet.delete(assistantMessageId);
                return newSet;
            });
            // Clear failed state
            setMessages(prev => prev.map(msg => 
                msg.id === assistantMessageId 
                    ? { ...msg, failed: false, status: 'complete' }
                    : msg
            ));
            return;
        }

        // Clear followup questions
        setFollowUpQuestions([]);

        // Increment retry count
        setMessageRetryCount(prev => ({
            ...prev,
            [assistantMessageId]: retryCount + 1
        }));

        // Replace assistant message with loading state (preserve ID and relationship!)
        setMessages(prev => prev.map(msg =>
            msg.id === assistantMessageId
                ? {
                    loading: true,
                    createdBy: "assistant",
                    id: assistantMessageId,
                    replyToUserMessageId: userMsg.id,
                    status: 'streaming'
                }
                : msg
        ));

        // Trigger streaming with the user message
        setTimeout(() => {
            setSessionId({
                sessionId: sessionId?.sessionId,
                messages: { body: userMsg.body },
                addMessage: true,
                isRetry: true
            });
        }, 100);
    }, [messages, messageRetryCount, sessionId, setFollowUpQuestions, setFailedMessages, setMessageRetryCount, setMessages, setSessionId]);

    // Handle like feedback - accepts ID or index
    const handleLikeFeedback = useCallback(async (messageIdentifier: string) => {
        const currentFeedback = messageFeedback[messageIdentifier];
        
        if (currentFeedback === 'like') {
            // User clicked like again - check if reset is allowed
            if (!feedbackSettings.submitted_feedback_can_reset) {
                // Feedback cannot be reset once submitted
                return;
            }
            
            // Remove feedback
            setMessageFeedback(prev => ({
                ...prev,
                [messageIdentifier]: null
            }));
            
            // Submit null feedback to backend to reset
            try {
                await ContractAPIS.submitMessageFeedback(messageIdentifier, null, null);
            } catch (error) {
                // Optionally revert the UI state on error
                setMessageFeedback(prev => ({
                    ...prev,
                    [messageIdentifier]: currentFeedback
                }));
            }
        } else {
            // Check if user is trying to switch from dislike to like
            if (currentFeedback === 'dislike' && !feedbackSettings.submitted_feedback_can_reset) {
                // Cannot switch feedback once submitted
                return;
            }
            
            // User clicked like (or switched from dislike)
            setMessageFeedback(prev => ({
                ...prev,
                [messageIdentifier]: 'like'
            }));
            
            // Trigger sprinkle animation
            setSprinklingMessages(prev => new Set(prev).add(messageIdentifier));
            
            // Remove sprinkle animation after it completes (600ms)
            setTimeout(() => {
                setSprinklingMessages(prev => {
                    const newSet = new Set(prev);
                    newSet.delete(messageIdentifier);
                    return newSet;
                });
            }, 600);
            
            // Submit thumbs up feedback to backend
            try {
                // If switching from dislike to like, we also need to clear the message (nullify it)
                const clearMessage = currentFeedback === 'dislike';
                await ContractAPIS.submitMessageFeedback(messageIdentifier, 'THUMBS_UP', clearMessage ? null : undefined);
            } catch (error) {
                // Optionally revert the UI state on error
                setMessageFeedback(prev => ({
                    ...prev,
                    [messageIdentifier]: currentFeedback
                }));
            }
        }
    }, [messageFeedback, feedbackSettings]);

    // Handle dislike feedback - opens modal, accepts ID or index
    const handleDislikeFeedback = useCallback(async (messageIdentifier: string) => {
        const currentFeedback = messageFeedback[messageIdentifier];
        
        if (currentFeedback === 'dislike') {
            // User clicked dislike again - check if reset is allowed
            if (!feedbackSettings.submitted_feedback_can_reset) {
                // Feedback cannot be reset once submitted
                return;
            }
            
            // Remove feedback
            setMessageFeedback(prev => ({
                ...prev,
                [messageIdentifier]: null
            }));
            
            // Submit null feedback and null message to backend to reset
            try {
                await ContractAPIS.submitMessageFeedback(messageIdentifier, null, null);
            } catch (error) {
                // Optionally revert the UI state on error
                setMessageFeedback(prev => ({
                    ...prev,
                    [messageIdentifier]: currentFeedback
                }));
            }
        } else {
            // Check if user is trying to switch from like to dislike
            if (currentFeedback === 'like' && !feedbackSettings.submitted_feedback_can_reset) {
                // Cannot switch feedback once submitted
                return;
            }
            
            // Open modal for dislike feedback
            setFeedbackMessageId(messageIdentifier);
            setFeedbackModalOpen(true);
        }
    }, [messageFeedback, feedbackSettings]);

    // Handle feedback modal submit
    const handleFeedbackSubmit = useCallback(async () => {
        if (!feedbackMessageId) return;
        
        setMessageFeedback(prev => ({
            ...prev,
            [feedbackMessageId]: 'dislike'
        }));
        
        // Submit thumbs down feedback to backend
        try {
            await ContractAPIS.submitMessageFeedback(
                feedbackMessageId, 
                'THUMBS_DOWN',
                feedbackText || null // Use null if empty to clear previous message
            );
        } catch (error) {
            // Revert the UI state on error
            setMessageFeedback(prev => ({
                ...prev,
                [feedbackMessageId]: null
            }));
        }
        
        // Close modal and reset
        setFeedbackModalOpen(false);
        setFeedbackMessageId(null);
        setFeedbackText('');
    }, [feedbackMessageId, feedbackText]);

    // Handle feedback modal cancel
    const handleFeedbackCancel = useCallback(() => {
        setFeedbackModalOpen(false);
        setFeedbackMessageId(null);
        setFeedbackText('');
    }, []);

    // Handle sending a message
    const handleSendMessage = async() => {
        if (!haveAIAccess) {
            errorToastify("You don't have enough credits to use this feature. Please contact admin.");
            return;
        }

        setRefetchCredits((prev) => prev + 1);

        if (!currentTypedUserMessage.trim()) return;
        
        // Save message before clearing it
        const userMessage = currentTypedUserMessage;
        setCurrentTypedUserMessage("");
        setSupplementaryReferences(null);
        setIsSupplementaryRefsDismissed(false);

        // ── Reset per-message guardrail tracking refs ────────────────────────────
        guardrailBlockedRef.current = false;
        guardrailResolvedRef.current = false;
        guardrailHandledRef.current = false;
        guardrailSafeResponseRef.current = '';
        pendingBlockedUserMsgRef.current = null;
        streamingSessionIdRef.current = null; // Reset session ID ref for new message

        try {
            setFollowUpQuestions([]);

            const currentMessage = {
                body: userMessage,
                sentBy: "current user",
                createdBy: "user",
                createdAt: "Now",
                guardRailsPass: '',
                id: generateFallbackMessageId()
            };

            // Store the current user message so the streaming side can reference it
            // when applying the block UI if guardrail resolves after stream has started
            pendingBlockedUserMsgRef.current = { id: currentMessage.id, body: userMessage };

            // Add user message + assistant loading placeholder with relationship
            setMessages(prev => [
                ...prev,
                currentMessage,
                { 
                    loading: true, 
                    createdBy: "assistant",
                    replyToUserMessageId: currentMessage.id,
                    status: 'streaming'
                }
            ]);

            // ── For claim_analysis: keep sequential (guardrails bypassed anyway) ─
            const ignoreGuardrails = CHAT_TYPE === 'claim_analysis';
            if (CHAT_TYPE === 'claim_analysis') {
                const guardRailsAnalysis = await ContractAPIS.getGuardRailsAnalysis(userMessage, true);
                guardrailResolvedRef.current = true;
                if (guardRailsAnalysis?.status === 'blocked') {
                    const GUARDRAIL_BLOCKED_MESSAGE = "We're Sorry, This request cannot be processed due to privacy and compliance rules. You may rephrase with a different question.";
                    const safeMsg = GUARDRAIL_BLOCKED_MESSAGE;
                    setMessages(prev => {
                        const withoutPlaceholder = prev.filter(
                            m => !(m.createdBy === 'assistant' && (m.replyToUserMessageId === currentMessage.id || m.loading))
                        );
                        return withoutPlaceholder.map(m => {
                            if (m.id === currentMessage.id) return { ...m, guardRailsPass: false };
                            return m;
                        }).concat([
                            {
                                id: generateFallbackMessageId(),
                                body: safeMsg,
                                createdBy: "assistant",
                                replyToUserMessageId: currentMessage.id,
                                status: 'complete',
                                createdAt: "Now",
                                guardRailsPass: false
                            }
                        ]);
                    });
                    return;
                }
                // Proceed with claim search
                try {
                    // Use whichever model is active (single selection mode for claim_analysis)
                    const activeModelId = reasoningModel?.id || quickModel?.id;
                    const searchResponse = await ContractAPIS.searchClaims(userMessage, preAiModeFilters, significanceFlag, activeModelId, confidenceScoreFlag);
                    setMessages(prevMessages => prevMessages.filter(msg => !msg?.loading));
                    if (searchResponse?.status === "success") {
                        const claimsMarkdown = `${searchResponse.summary || "No filters are applied."}`;
                        setMessages(prev => [
                            ...prev,
                            {
                                body: claimsMarkdown,
                                createdBy: "assistant",
                                createdAt: "Now",
                                id: generateFallbackMessageId()
                            }
                        ]);
                        const aiSignificantVariance = searchResponse.significant_variance !== undefined
                            ? searchResponse.significant_variance
                            : significanceFlag;
                        // Extract confidence_score from AI response; fall back to the current flag value
                        const aiConfidenceScore = searchResponse.confidence_score !== undefined
                            ? Boolean(searchResponse.confidence_score)
                            : confidenceScoreFlag;
                        if (onFiltersUpdate) {
                            onFiltersUpdate(searchResponse.filters_nl || '', (searchResponse.filters && Object.keys(searchResponse.filters).length > 0) ? searchResponse.filters : null, searchResponse.top_k, searchResponse.sort, aiSignificantVariance, aiConfidenceScore);
                        }
                        if (onMessageSent) {
                            onMessageSent();
                        }
                    } else {
                        setMessages(prev => [
                            ...prev,
                            {
                                body: 'No results found for your query.',
                                createdBy: "assistant",
                                createdAt: "Now",
                                id: generateFallbackMessageId(),
                            }
                        ]);
                    }
                } catch (error) {
                    generateErrorToaster(error, error?.payload?.detail);
                    setMessages(prev => [
                        ...prev.filter(msg => !msg?.loading),
                        {
                            body: error?.message || 'An error occurred while searching claims.',
                            createdBy: "assistant",
                            createdAt: "Now"
                        }
                    ]);
                }
                return;
            }

            // ── Parallel path for claim / contract chat ──────────────────────────
            // Build the initial payload for creating a session
            let streamPayload: any = {
                messages: [{ body: userMessage }],
                type: CHAT_TYPE,
            };

            if (CHAT_TYPE === 'claim') {
                streamPayload.claim_analysis_details_id = contractId;
            } else {
                streamPayload.contractIds = (selected?.length > 0 || sessionDetails?.contractIds)
                    ? (selected?.length > 0 ? selected : sessionDetails?.contractIds)?.map(item => item?.id)
                    : [contractId];
            }

            // Optional: send intent override if not 'auto'
            if (chatActions.selected !== 'auto') {
                streamPayload.intent_type = chatActions.selected;
            }

            // Optional: send model overrides if present
            if (reasoningModel?.id) {
                streamPayload.reasoning_model = reasoningModel.id;
            }
            if (quickModel?.id) {
                streamPayload.explanatory_model = quickModel.id;
            }

            // Fire guardrail check in background — result is communicated via refs
            // so the streaming useData hook can react to it without stale closures.
            ContractAPIS.getGuardRailsAnalysis(userMessage, ignoreGuardrails)
                .then(guardRailsAnalysis => {
                    const isBlocked = guardRailsAnalysis?.status === 'blocked';
                    guardrailBlockedRef.current = isBlocked;
                    const GUARDRAIL_BLOCKED_MESSAGE = "We're Sorry, This request cannot be processed due to privacy and compliance rules. You may rephrase with a different question.";
                    guardrailSafeResponseRef.current = isBlocked
                        ? GUARDRAIL_BLOCKED_MESSAGE
                        : '';
                    guardrailResolvedRef.current = true; // Signal: guardrail done

                    // ── Case 1: Guardrail responds BEFORE stream starts ──────────────
                    // If streaming hasn't kicked off yet (no sessionId), apply block UI directly
                    // and skip triggering the stream.
                    if (isBlocked && !streamingSessionIdRef.current) {
                        if (guardrailHandledRef.current) return;
                        guardrailHandledRef.current = true;
                        
                        const safeMsg = guardrailSafeResponseRef.current;
                        setMessages(prevMessages => {
                            // Remove ANY assistant message replying to the current user message,
                            // even if it transitioned from 'loading' to 'stream'.
                            const withoutPlaceholder = prevMessages
                                .map(msg => {
                                    if (msg?.id === currentMessage?.id) {
                                        return { ...msg, guardRailsPass: false };
                                    }
                                    return msg;
                                })
                                .filter(msg => !(msg.createdBy === 'assistant' && (msg.replyToUserMessageId === currentMessage.id || msg.loading)));
                            return [
                                ...withoutPlaceholder,
                                {
                                    id: generateFallbackMessageId(),
                                    body: safeMsg,
                                    createdBy: "assistant",
                                    replyToUserMessageId: currentMessage.id,
                                    status: 'complete',
                                    createdAt: "Now",
                                    guardRailsPass: false
                                }
                            ];
                        });
                    }
                    // Case 2 (blocked mid-stream) is handled inside the streaming useData hook
                    // via checkGuardrailMidStream(), which polls guardrailResolvedRef.
                })
                .catch(() => {
                    // On guardrail API error: treat as allowed so user isn't stuck
                    guardrailBlockedRef.current = false;
                    guardrailResolvedRef.current = true;
                });

            // ── Trigger streaming immediately (parallel with guardrail) ───────────
            if (!sessionId?.sessionId) {
                setSendMessagePayload(streamPayload);
            } else {
                setSessionId({
                    ...sessionId,
                    messages: { body: userMessage },
                    addMessage: true
                });
            }

        } catch (error) {
            setIsSending(false);
            if (error?.message) {
                setMessages(prev => [
                    ...prev,
                    { body: error.message, sentBy: "assistant", createdAt: "Now" }
                ]);
            }
        }
        
        setFollowUpQuestions([]);
    };



    const handlePagination = async (lastMessageId: string) => {
        setSessionId((prev) => ({ ...prev, lastMessageId }));
        setLastMessageId(lastMessageId);
        localStorage.setItem(
            lastMessageId ? `lastMessageId-${sessionId.sessionId}` : "",
            lastMessageId || ""
        );
    };

    let lastScrollTop = 0; // Define this outside the function (e.g., in a ref or component scope)

    const handleScrollTop = (event: Event) =>{
                const target = event.currentTarget as HTMLDivElement;
        const { scrollTop, scrollHeight, clientHeight } = target;

        // Determine scroll direction
        const isScrollingUp = scrollTop < lastScrollTop;
        lastScrollTop = scrollTop;

        // Scroll to bottom logic
        if (scrollTop + clientHeight >= scrollHeight - 20) {
            setIsManuallyScrolling(false);
            setNewMessageReceived(false);
            if (newMessageBtnRef.current) {
                newMessageBtnRef.current.style.display = "none";
            }
        } else {
            setIsManuallyScrolling(true);
        }
    }

    const handleScroll = (event: Event) => {
        const target = event.currentTarget as HTMLDivElement;
        const { scrollTop } = target;

        // Determine scroll direction
        const isScrollingUp = scrollTop < lastScrollTop;
        lastScrollTop = scrollTop;


        // * If scroll is near the top AND user is scrolling up, fetch older messages
        if (isScrollingUp && scrollTop <= 10) {
            const lastMessageRef = messages[messages.length - 1];
            const dataRef = !!localStorage.getItem(
                `lastMessageId-${sessionId.sessionId}`
            );
            if (!dataRef || lastMessageRef?.id) {
                handlePagination(lastMessageRef?.id);
            }
        }
    };

    // Handle external message from parent (AI filter input)
    useEffect(() => {
        if (externalMessage && externalMessage.trim() && externalMessage !== externalMessageProcessedRef.current) {
            externalMessageProcessedRef.current = externalMessage;
            setCurrentTypedUserMessage(externalMessage);
            // Trigger send after setting the message
            setTimeout(() => {
                handleSendMessage();
                onMessageSent?.();
            }, 100);
        }
    }, [externalMessage]);

    // ! Detect new message received (New Message Listening)
    useEffect(() => {
        if (messages.length > 0 && isManuallyScrolling) {
            const lastMessage = messages[messages.length - 1];
            if (
                lastMessage?.createdBy === "assistant" ||
                lastMessage?.loading
            ) {
                setNewMessageReceived(true);
                if (newMessageBtnRef.current) {
                    newMessageBtnRef.current.style.display = "flex";
                }
            }
        }
    }, [messages, isManuallyScrolling]);

    // * Attach scroll event listener to the chat container
    useEffect(() => {
        const container = chatBotContainer.current.closest(
            ".chatbot-container-scrollbar"
        );
        const needBindEvent = !!localStorage.getItem("removeScrollEvent");
        
        if (container) {
            if(Boolean(needBindEvent)) {
                // container.addEventListener("scroll", handleScroll);
            }else {
                container.addEventListener("scroll", handleScrollTop);
            }
            
                
        }

        return () => {
            // container.removeEventListener("scroll", handleScroll);
            container.removeEventListener("scroll",handleScrollTop)
            localStorage.removeItem('removeScrollEvent')
        }
    }, [chatBotContainer]);

    // On page load check if the chat type is claim trigger an API and on response
                                

    const claimSummary = useData(
        async (abort) => {
            try {
                // Skip summary for claim_analysis type (no individual claim/contract)
                if (CHAT_TYPE === 'claim_analysis') return;
                if (!claimNumber && !contractId) return;
                if(!haveAIAccess) return;
                
                // Check if we're in history view - use resolvedSessionId instead of urlSessionId
                const isHistoryView = Boolean(resolvedSessionId) && Number(resolvedSessionId) !== 0;
                
                // For new chats: skip if messages already exist
                // For history views: allow loading even if messages exist (summary needs to be fetched separately)
                const hasSummaryMessage = messages.length > 0 && messages[0]?.summary;
                
                if (!isHistoryView && messages.length !== 0) return;
                if (isHistoryView && hasSummaryMessage) return; // Already have summary in history
                
                // Show summary in these cases:
                // 1. Claim chat (always) - unchanged
                // 2. Contract chat with SINGLE contract only (new or history)
                // Do NOT show for multi-contract (new or history)
                

                // Strictly wait for sessionDetails in history view
                // We need sessionDetails to know if it's a multi-contract session
                if (isHistoryView && (isFetchingSessionDetails || !sessionDetails)) {
                    return;
                }
                
                const hasMultipleContracts = (selected?.length > 1) || (sessionDetails?.contractIds?.length > 1);
                const isSingleContract = CHAT_TYPE !== 'claim' && !hasMultipleContracts;

                // Show summary in these cases:
                // 1. Claim chat (always)
                // 2. Contract chat with SINGLE contract only (new or history)
                // Do NOT show for multi-contract (new or history)
                
                // For contract type, show initial loading message
                // For claim type, skip this because it will be replaced immediately by the streamed version below
                if(isSingleContract) {
                    setMessages((prevMessages) => [
                        {
                            body: `Hold on while getting the details against contract-${contractId}…`,
                            createdBy: "assistant",
                            createdAt: "Now",
                            loadingSpin: true,
                        },
                        ...prevMessages,
                    ]);
                }
                if (CHAT_TYPE === 'claim') {
                    // Use streamed claim summary endpoint and stream into chat messages
                    setMessages((prevMessages) => [
                        {
                            body: `Hold on while getting the details against claim-${claimNumber}…`,
                            createdBy: "assistant",
                            createdAt: "Now",
                            loadingSpin: true,
                            stream: true,
                        },
                        ...prevMessages,
                    ]);

                    try {
                        const streamResponse = await ContractAPIS.getClaimsSummaryStream(contractId);
                        const reader = streamResponse?.body?.getReader();
                        const decoder = new TextDecoder('utf-8');
                        let fullAssistantText = '';

                        if (reader) {
                            const { followUpQuestions: allFollowUpQuestions } = await parseStreamResponseBasedOnReader(
                                reader, 
                                decoder, 
                                fullAssistantText, 
                                setMessages, 
                                sessionId,
                                null, // onStreamStart
                                null, // onStreamEnd
                                null // onMessageId
                            );
                            setFollowUpQuestions(allFollowUpQuestions);
                            setMessages((previous) => {
                                if (previous.length === 0) return previous;

                                const updated = [...previous];
                                updated[0] = {
                                    ...updated[0],
                                    loading: false,
                                    loadingSpin: false,
                                    stream: undefined,
                                    summary: true
                                };
                                return updated;
                            });
                            return; // streaming handled; skip polling
                        }
                    } catch (err) {
                        throw new Error('Claim summary stream failed: ' + err.message);
                    }
                }

                if (isSingleContract) {
                    const POOL_MAX_REQUEST = 10;
                    const POOL_INTERVAL = 10000; // 10 seconds
                    let attempt = 0;

                    async function pollSummary(): Promise<any> {
                        try {
                            // Check for abort before each poll
                            if (abort?.aborted)
                                throw new Error("Polling aborted");

                            const res = await ContractAPIS.poolSummaryDataContract(contractId);

                            if (abort?.aborted)
                                throw new Error("Polling aborted");

                            // Final success: summary is ready
                            if (res?.status === "200" && res?.summary) {
                                setMessages((prevMessages) => [
                                    {
                                        body: stripAiMarkers(res?.summary),
                                        createdBy: "assistant",
                                        createdAt: "Now",
                                        loadingSpin: false,
                                        summary: true,
                                    },
                                    ...prevMessages.slice(1),
                                ]);
                                return res;
                            }

                            // Not ready yet: continue polling
                            if (
                                res?.status === "201" &&
                                res?.status !== "200"
                            ) {
                                attempt++;
                                if (attempt >= POOL_MAX_REQUEST) {
                                    throw new Error(
                                        "Polling timeout: max attempts reached"
                                    );
                                }
                                await new Promise((resolve) =>
                                    setTimeout(resolve, POOL_INTERVAL)
                                );
                                return await pollSummary(); // Recursively poll
                            } else if (res?.status === "404") {
                                // No summary available, return empty
                                setMessages((prevMessages) => [
                                    {
                                        body: CHAT_TYPE !== 'contract' ? `No summary available for this claim.` : `No summary available for this contract.`,
                                        createdBy: "assistant",
                                        createdAt: "Now",
                                        loadingSpin: false,
                                        summary: true,
                                    },
                                    ...prevMessages.slice(1),
                                ]);
                                return res;
                            }

                            // Any unexpected status: stop polling
                            throw new Error(
                                "Unexpected response during polling"
                            );
                        } catch (err) {
                            if (abort?.aborted) {
                                // * Optionally, we can handle cleanup here
                                return;
                            }
                            throw new Error("Polling failed: " + err.message);
                        }
                    }

                    return await pollSummary();
                }
                // For multi-contract chats, simply skip summary loading without showing error
            } catch (error) {
                 setMessages((prevMessages) => [
                    {
                        body:
                            error?.payload?.detail?.message || error?.detail?.message || error?.message ||
                            "Failed to fetch claim summary. Please try again later.",
                        createdBy: "assistant",
                        createdAt: "Now",
                        loadingSpin: false,
                        loading: false,
                        error: true,
                    },
                    ...prevMessages.filter(msg => !msg?.loadingSpin), // Remove loading spinner, keep other messages
                ]);
            }
        },
        [CHAT_TYPE, claimNumber, contractId, reloadChat, haveAIAccess, selected, sessionDetails, isFetchingSessionDetails, urlSessionId]
    );



    const haveLoadingMessages = useMemo(() => {
        return messages.some((msg) => msg?.loading || msg?.loadingSpin);
    }, [messages]);

    const chatHaveError = useMemo(() => {
        return messages.some((msg) => msg?.error);
    }, [messages]);

    useEffect(() => {
        // Skip auto-focus in embedded mode (claim analysis)
        if (disableAutoFocus) return;
        
        const lastMessage = messages[messages.length - 1];

        const shouldSkipFocus =
            lastMessage?.loading ||
            lastMessage?.stream ||
            claimSummary.isPending ||
            haveLoadingMessages ||
            chatHaveError;

        if (!isEditingTitle && !shouldSkipFocus) {
            document.getElementById("question")?.focus();
        }
    }
    , [
        isEditingTitle,
        messages[messages.length - 1], // only depend on last message
        claimSummary.isPending,
        haveLoadingMessages,
        chatHaveError,
        disableAutoFocus,
    ]);


    return (
        <Stack
            spacing={1}
            sx={{
                ...(height ? { height } : {}),
                padding: '10px'
            }}
        >
            <Stack
                direction="row"
                spacing={1}
                className={classes.contractStack}
            >
                <Typography className={classes.contractLabel}>
                    {
                        CHAT_TYPE === "claim"
                            ? "Claim:"
                        : CHAT_TYPE==='contract'?
                        "Contracts:"
                        : null
                    }
                </Typography>
                {(isFetchingAllContracts || isFetchingSessionDetails) && (
                    <CircularProgress size={20} />
                )}
                {CHAT_TYPE === "contract" && ((selected?.length > 0 ? selected : sessionDetails?.contractIds) || [])?.map((c) => {
                    const cleanName = c?.name?.replace(/\s*\(\d+\)\s*$/, '');
                    return c?.name ? <Chip key={c?.id} label={cleanName} className={classes.chip} /> : null;
                })}
                {
                    CHAT_TYPE === "claim" && contractId && (
                        <Link to={`/cms/claimAnalysis/view/${contractId}`} className={classes.link}>
                            {claimNumber}
                        </Link>
                    )
                }
                {CHAT_TYPE !== "claim" && contractName &&
                    contractId &&
                    !sessionDetails?.contractIds &&
                    (isFetchingContracts || isFetchingSessionDetails ? (
                        <CircularProgress size={20} />
                    ) : (
                       CHAT_TYPE !== "claim" ? <Chip label={contractName} className={classes.chip} />:<></>
                    ))}
            </Stack>

            {/* Jump to Latest button - shown in header when new messages arrive */}
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
                <Button 
                    variant="contained" 
                    color="primary" 
                    size="small"
                    ref={newMessageBtnRef}
                    style={{ display: newMessageReceived ? "flex" : "none" }}
                    startIcon={<ArrowDownwardIcon />}
                    onClick={() => {
                        if (bottomRef.current) {
                            bottomRef.current.scrollIntoView({ behavior: "smooth" });
                            setNewMessageReceived(false);
                        }
                    }}
                >
                    Jump to Latest
                </Button>
            </Box>

            {!!CHAT_TYPE && !haveAIAccess && isFetchingCredits == null && (
                <Typography sx={{ color: "red" }}>
                    <b>Note:</b>{" "}
                    {!clientHaveAIAccess
                        ? "AI Features are disabled for this client, Contact admin"
                        : "You don’t have enough credits to use this feature. Contact the admin to upgrade."}
                </Typography>
            )}

            <Loadable
                loading={
                    CHAT_TYPE !== 'claim' && (!sessionId 
                        // && fetchingMessages != null) || (isFetchingCredits!=null
                        )
                }
                parentClassName={`${classes.chatbot} chatbot-container-scrollbar chat--loading`}
            >
                <Stack direction="column" spacing={1} className={classes.chatbot} ref={chatBotContainer}>
                    {messages?.length === 0 && (
                        <Box className={classes.botContainer}>

                            <Box className={classes.botText}>
                                {CHAT_TYPE === "claim_analysis" ? "This is SlicedIQ Semantic Search. You can ask questions about the claims data and filter results directly from the Claims Analysis grid." : "This is a SlicedIQ Insights. You can ask questions " + CHAT_TYPE + "about the " + (CHAT_TYPE === "claim" ? "claim" : "contracts") + " and get answers."}
                            </Box>
                        </Box>
                    )}
                    {renderedMessages}
                    <FollowUpList 
                        questions={followUpQuestions} 
                        setMessage={setCurrentTypedUserMessage}
                        inputElement={inputElementRef.current}
                    />
                    <div ref={bottomRef} />
                </Stack>
            </Loadable>
            
            {/* Supplementary References */}
            {!isSupplementaryRefsDismissed && supplementaryReferences && (supplementaryReferences.supp_kb?.length > 0 || supplementaryReferences.supp_prompt?.used) && (
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        mt: 1,
                        mb: 1,
                        p: 1.5,
                        pr: 5,
                        borderRadius: '8px',
                        flexWrap: 'wrap',
                        gap: '8px',
                        alignItems: 'center',
                        backgroundColor: '#f2f2f2',
                        position: 'relative'
                    }}
                >
                    <IconButton
                        size="small"
                        sx={{
                            position: 'absolute',
                            top: 6,
                            right: 6
                        }}
                        onClick={() => setIsSupplementaryRefsDismissed(true)}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                    {supplementaryReferences.supp_kb?.map((doc, idx) => {
                        const label = `Reference Document: ${getSupplementaryDocLabel(doc)}`;
                        return (
                            <Tooltip title={label} key={idx} placement="top">
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    startIcon={<InsertDriveFileOutlinedIcon fontSize="small" />}
                                    endIcon={<OpenInNewIcon fontSize="small" />}
                                    onClick={() => openSupplementaryDocumentPreview(doc)}
                                    sx={{
                                        borderRadius: '4px',
                                        textTransform: 'none',
                                        borderColor: 'primary.main',
                                        color: 'primary.main',
                                        maxWidth: '220px',
                                        justifyContent: 'flex-start',
                                        '& .MuiButton-startIcon': { flexShrink: 0 },
                                        '& .MuiButton-endIcon': { flexShrink: 0 },
                                    }}
                                >
                                    <Box
                                        component="span"
                                        sx={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            display: 'block'
                                        }}
                                    >
                                        {label}
                                    </Box>
                                </Button>
                            </Tooltip>
                        );
                    })}
                    {supplementaryReferences.supp_prompt?.used && (
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            startIcon={<AutoAwesomeOutlinedIcon fontSize="small" />}
                            onClick={() => {
                                const promptId = supplementaryReferences?.supp_prompt?.id;
                                if (promptId) {
                                    window.open(`/cms/supplementary-prompts/edit/${promptId}`, "_blank");
                                }
                            }}
                            sx={{
                                borderRadius: '4px',
                                textTransform: 'none',
                                borderColor: 'primary.main',
                                color: 'primary.main'
                            }}
                        >
                            Reference Prompt
                        </Button>
                    )}
                </Stack>
            )}

            <FormControl
                variant="outlined"
                sx={{
                    filter:
                        !!CHAT_TYPE
                        ? (!haveAIAccess || (urlSessionId == sessionId?.sessionId && sessionDetails?.isReadOnly) || sessionDetails?.isReadOnly) 
                            ? "blur(3px)"
                            : null
                        : claimSummary.isPending || haveLoadingMessages || chatHaveError
                        ? "blur(3px)"
                        : null,
                    }}
            >
                <InputLabel htmlFor="outlined-adornment-question">
                    Ask a question
                </InputLabel>
                <OutlinedInput
                    autoFocus={!disableAutoFocus}
                    margin="dense"
                    disabled={
                        messages[messages.length - 1]?.loading ||
                        messages[messages.length - 1]?.stream ||
                        claimSummary.isPending ||
                        haveLoadingMessages ||
                        chatHaveError || (urlSessionId == sessionId?.sessionId && sessionDetails?.isReadOnly) //read-only applies if sessionId in URL matches localState (case handled for new chat btn)
                        || !haveAIAccess
                        || sessionDetails?.isReadOnly
                    }
                    id="question"
                    inputRef={inputElementRef}
                    label="Ask a question"
                    onChange={(e) => setCurrentTypedUserMessage(e.target.value)}
                    value={currentTypedUserMessage}
                    type="text"
                    fullWidth
                    onKeyDown={(e) => {
                        if (
                            e.key === "Enter" &&
                            !e.shiftKey &&
                            (CHAT_TYPE !== "" ? haveAIAccess : true)
                        ) {
                            e.preventDefault();
                            handleSendMessage();
                        }
                    }}
                    multiline
                    rows={2}
                    endAdornment={
                        <InputAdornment position="end">
                            {CHAT_TYPE !== "" && enableResponseFilters && (
                                <div>
                                    <ToggleButtonGroup
                                        value={chatActions.selected}
                                        exclusive
                                        color="primary"
                                        className="chat-action-buttons"
                                        onChange={(event, newValue) => {
                                            if (newValue !== null) {
                                                setChatActions({
                                                    selected: newValue,
                                                });
                                            }
                                        }}
                                        disabled={
                                            messages[messages.length - 1]?.loading ||
                                            messages[messages.length - 1]?.stream ||
                                            claimSummary.isPending ||
                                            haveLoadingMessages ||
                                            chatHaveError ||
                                            !haveAIAccess
                                        }
                                        size="medium"
                                    >
                                        <Tooltip title="Quick Response" placement='top'>
                                            <ToggleButton value="explanatory">
                                                <SvgIcon
                                                    id="chat-speed"
                                                    width={15}
                                                    height={15}
                                                />
                                            </ToggleButton>
                                        </Tooltip>
                                        <Tooltip
                                            title="Reasoning"
                                            placement='top'
                                        >
                                            <ToggleButton value="reasoning">
                                                <SvgIcon
                                                    id="chat-brain"
                                                    width={15}
                                                    height={15}
                                                />
                                            </ToggleButton>
                                        </Tooltip>
                                    </ToggleButtonGroup>
                                </div>
                            )}
                            <IconButton
                                size="small"
                                onClick={isStreaming || isSending ? handleStopResponse : handleSendMessage}
                                disabled={
                                    isSending ||
                                    (
                                        !isStreaming &&
                                        !isSending &&
                                        (
                                            !currentTypedUserMessage.trim() ||
                                            (CHAT_TYPE !== "claim" ? !haveAIAccess : false) ||
                                            !!claimSummary.isPending
                                        )
                                    )
                                }
                                color={isStreaming || isSending ? "error" : "default"}
                                >
                                {isStreaming || isSending ? (
                                    <StopCircleIcon fontSize="medium" />
                                ) : (
                                    <SendIcon fontSize="medium" />
                                )}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>
            
            {/* Feedback Modal for Dislike */}
            <Dialog 
                open={feedbackModalOpen} 
                onClose={handleFeedbackCancel}
                maxWidth="sm"
                fullWidth
            >
                <Box sx={{ p: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        Help us improve
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Please tell us what went wrong with this response
                    </Typography>
                    
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        placeholder="What was the issue with this response? (Optional)"
                        value={feedbackText}
                        onChange={(e) => setFeedbackText(e.target.value)}
                        sx={{ mb: 2 }}
                    />
                    
                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                        <Button 
                            onClick={handleFeedbackCancel}
                            variant="outlined"
                        >
                            Cancel
                        </Button>
                        <Button 
                            onClick={handleFeedbackSubmit}
                            variant="contained"
                            color="primary"
                        >
                            Submit
                        </Button>
                    </Stack>
                </Box>
            </Dialog>
        </Stack>
    );
};

export const AiChatPage = ({
    selected,
    height = undefined,
    defaultTitle = null,
    onClose = null,
    match: { params: { directoryId } = {directoryId:undefined} } = {},
    // New props for embedded mode (claim analysis)
    isEmbedded = false,
    chatType: propChatType = null,
    claimAnalysisId = null,
    claimNumber: propClaimNumber = null,
    selectedClaimIds = [],
    totalClaimsCount = 0,
    headerActions = null, // Slot for action buttons (expand/close)
    externalMessage = '', // Message from external input (AI filter)
    onMessageSent = null, // Callback when message is sent
    onFiltersUpdate = null, // Callback to update filters from AI response
    isSidebarMode = false, // Whether chat is in sidebar mode (affects button positioning)
    enableResponseFilters = true, // Whether to show response type options (Reasoning, Quick Response, Auto)
    newChatbutton = { enable: true, text: 'New Chat' }, // Customize New Chat button
    enableIconTitle = false, // Show SlicedIQ icon after title
    queryContractId: propQueryContractId = null,
    querySessionId: propQuerySessionId = null,
    isPatientDetailsVisible = false,
    enableFeedback = true, // Whether to show feedback buttons (thumbs up/down)
    onClearAllFilters = null, // Callback to clear all filters
    preAiModeFilters = null, // Filters applied before AI mode was enabled
    significanceFlag = false, // Whether Significant Variance is currently active
    confidenceScoreFlag = false, // Whether to include low-confidence claims (super_admin only)
    // ── LLM model override (SuperAdmin only; undefined = use platform default) ──
    reasoningModel = null,
    quickModel = null,
    // ── Full-width model switcher row slot (SuperAdmin only) ──
    modelSwitcherSlot = null,
    availableModels = { explanatory: [], reasoning: [] }
}: any) => {    
    useFitHeight();
    
    // Read from URL query parameters (for sidebar mode) or route params
    const location = useLocation();
    
    // Memoize query params to prevent creating new values on every render
    const { queryContractId, querySessionId } = useMemo(() => {
        // Prioritize props if provided (state-based sidebar)
        if (propQueryContractId !== null || propQuerySessionId !== null) {
            return {
                queryContractId: propQueryContractId !== null ? parseInt(propQueryContractId.toString()) : null,
                querySessionId: propQuerySessionId !== null ? parseInt(propQuerySessionId.toString()) : null
            };
        }

        // Fallback to URL query parameters (legacy sidebar mode)
        const outerQueryParams = new URLSearchParams(location.search);
        const queryContractIdStr = outerQueryParams.get('contractId');
        const querySessionIdStr = outerQueryParams.get('sessionId');
        
        return {
            queryContractId: queryContractIdStr !== null ? parseInt(queryContractIdStr) : null,
            querySessionId: querySessionIdStr !== null ? parseInt(querySessionIdStr) : null
        };
    }, [location.search, propQueryContractId, propQuerySessionId]);
    
    const [title, setTitle] = useState(defaultTitle);
    const [isFHIRConfigured, setIsFHIRConfigured] = useState(false);
    const [isPatientDetailsOpen, setPatientDetailsOpen] = useState(false);
    const [previousTitle, setPreviousTitle] = useState(defaultTitle || "Untitled");
    const [isEditingTitle, setIsEditingTitle] = useState(false);
    const [messages, setMessages] = useState([]);
    const [sessionId, setSessionId] = useState<any>({});
    const classes = useStyles();
    let TITLE_MAX_LENGTH = 100;
    const ContractAPIS = new ContractInfo();
    const { sessionId: urlSessionId }: any = useParams();
    const resolvedSessionId = (querySessionId !== null && querySessionId !== undefined) ? querySessionId : urlSessionId;
    const [updateTitle, setUpdateTitle] = useState(null);
    const [reloadChat,setReloadChat] = useState(new Date().getTime())
    const newMessageBtnRef = useRef<HTMLButtonElement>(null);
    const chatBotContainer = useRef<HTMLDivElement>(null);
    const [currentTypedUserMessage, setCurrentTypedUserMessage] = useState("");
    const [followUpQuestions, setFollowUpQuestions] = useState<string[]>([]);
    const clients: any = useSelector<RootState>(
            state => state.clients.tinyList?.filter((item)=>item?.active)
        );
        let selectedClient: any = useSelector<RootState>(
            state => state.dashboards.selectedClient
        );
        const sessionUserClientId = useSelector<RootState>(selectSessionUserClientId);
        
        // Use sessionUserClientId as fallback for Admin users who don't have selectedClient
        const effectiveClientId = selectedClient || sessionUserClientId;
        
        const currentSelectedClient =
            clients?.find(client => client.clientId === effectiveClientId)?.clientId ||
            "";


    const messagesLengthRef = useRef(messages.length);
    const lastMonthlyLimitsRef = useRef(null);
    const [refetchCredits, setRefetchCredits] = useState(0);

    useEffect(() => {
    messagesLengthRef.current = messages.length;
    }, [messages]);

    const {
        data: creditsData,
        error: getLimitsError,
        isPending: monthlyLimitsPending
        } = useData(async () => {
        // Fetch credits for all users
        if (!effectiveClientId) {
            // Return cached data (previous successful one)
            return lastMonthlyLimitsRef.current;
        }

        const newLimits = await getEAPGCreditUsage("ai");
        // Cache the latest limits
        lastMonthlyLimitsRef.current = newLimits;
        return newLimits;
    }, [effectiveClientId, refetchCredits]);





    const handleTitleSave = () => {
        if(!title && !isEditingTitle) {
            setTitle("Untitled");
        }
        // Validate title before saving must be within 100 characters
        if (title && title.length > TITLE_MAX_LENGTH) {
            errorToastify("Title must be within 100 characters");
            return;
        }

        // Save the title to the session or wherever needed
        if (sessionId?.sessionId) {
            const updatedSession = { ...sessionId, title: title || "Untitled" };
            // setSessionId(updatedSession);
            setUpdateTitle(new Date().getTime()); // Trigger re-render
            setIsEditingTitle(false);
            // setTitle(title || "Untitled");

            // Optionally, you can also save the title to the server here
        }
        setIsEditingTitle(false);
    }

    const { data, isPending }: any =
        useData(
            async (abort) => {
                if(!title) {
                    return;
                }

                if(!updateTitle) {
                    return;
                }
                if (!updateTitle && !urlSessionId && !sessionId?.sessionId){
                    return;
                };

                const response = await ContractAPIS.updateChatSessionTitle(
                   sessionId?.sessionId ||  urlSessionId,
                    title
                );
                setTitle(response?.title || title || "Untitled");
                setPreviousTitle(response?.title || title || "Untitled");
                setUpdateTitle(null)
                return { contractIds: response?.title || "Untitled"};
            },
            [updateTitle, resolvedSessionId, sessionId]
        );

        const {} = useData(async () => {
        if(isPatientDetailsVisible){
            try{
                const response = await checkIfFHIRConfigExists();
                setIsFHIRConfigured(response);
                return response;
            }
            catch(error){
                console.error(error);
            }
        }
        
    }, [isPatientDetailsVisible]);

    const { search } = useLocation(); // gives ?query=hello
    const queryParams = new URLSearchParams(search);
    const urlClaimNumber = queryParams.get("claimNumber");
    // Use prop claimNumber if provided, otherwise use URL param
    const claimNumber = propClaimNumber || urlClaimNumber;
    const {contractId: urlContractId}: any = useParams();
    // Use claimAnalysisId prop if provided, otherwise use URL contractId
    const contractId = claimAnalysisId || urlContractId;
    const lastRemainingPercentageRef = useRef(0);
    const lastLabelRef = useRef("0 / 0 Credits Used");
    const usagePercentage = useRef<HTMLDivElement>(null);

    const CHAT_TYPE = useMemo(() => {
        // Use prop chatType if provided
        if (propChatType) {
            return propChatType;
        }
        if (claimNumber) {
            return "claim";
        } else {
            return "contract";
        }
    }, [propChatType, claimNumber]);


    const aiLimits = useMemo(() => {
        return creditsData || null;
    }, [creditsData]);

    // Calculate remaining credits percentage
    const remainingPercentage = useMemo(() => {
        if (!aiLimits?.totalLimit || aiLimits.totalLimit === 0) return 0;

        const usedPercentage =
            (aiLimits.usedCredits / aiLimits.totalLimit) * 100;
        const remaining = Math.max(0, Math.floor(100 - usedPercentage)); // prevent negatives

        // store last valid calculated percentage
        lastRemainingPercentageRef.current = remaining;   

        return remaining;
    }, [aiLimits]);



    // Label text
    const label = useMemo(() => {
         if (!aiLimits) return lastLabelRef.current;

        const lbl = `${aiLimits?.usedCredits || 0} / ${
            aiLimits?.totalLimit || 0
        } Credits Used (${remainingPercentage}% Remaining)`;

        lastLabelRef.current = lbl;
        return lbl;
    }, [aiLimits, remainingPercentage]);

    // Color logic based on remaining credits
    const color = useMemo(() => {
        if (lastRemainingPercentageRef.current >= 40) return "success"; 
        if (lastRemainingPercentageRef.current >= 20) return "warning"; 
        return "danger"; 
    }, [lastRemainingPercentageRef.current]);


    useEffect(() => {
        if (usagePercentage.current) {
            const el = usagePercentage.current;
            setTimeout(() => {
                if (el) {
                    el.style.display = lastRemainingPercentageRef.current <= 20 ? 'flex' : 'none';
                }
            }, 2000);
        }
    }, [usagePercentage]);

    // Handler for New Chat action
    const handleNewChat = useCallback(() => {
        setMessages([]);
        setSessionId({});
        setTitle(null);
        setPreviousTitle(null);
        setReloadChat(new Date().getTime());
        setCurrentTypedUserMessage("");
        setFollowUpQuestions([]);
        
        // Call the clear filters callback if provided
        if (onClearAllFilters) {
            onClearAllFilters();
        }
    }, [setMessages, setSessionId, setTitle, setPreviousTitle, setReloadChat, setCurrentTypedUserMessage, setFollowUpQuestions, onClearAllFilters]);



    // Embedded mode - render with header but without Portlet wrapper
    if (isEmbedded) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', height: height || '100%', width: '100%' }}>
                {/* Header for embedded mode - Two rows */}
                <Box sx={{ 
                    borderBottom: '1px solid #e0e0e0',
                    backgroundColor: '#fff',
                    flexShrink: 0,
                }}>
                    {/* Top row - Title + fixed action buttons */}
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '10px 16px 6px 16px',
                        gap: '8px',
                    }}>
                        {/* Title — flex: 1 to take remaining space */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, minWidth: 0 }}>
                            {isEditingTitle ? (
                                <Stack direction="row" alignItems="center" gap={1} sx={{ flex: 1, minWidth: 0 }}>
                                    <TextField
                                        value={(!title && !isEditingTitle) ? "Untitled" : title}
                                        onChange={e => setTitle(e.target.value)}
                                        onKeyDown={e => {
                                            if (e.key === "Enter" && title) {
                                                handleTitleSave();
                                            } else if (e.key === "Escape") {
                                                setIsEditingTitle(false);
                                                setTitle(previousTitle || "Untitled");
                                            }
                                        }}
                                        autoFocus
                                        size="small"
                                        variant="standard"
                                        sx={{ flex: 1, minWidth: 0 }}
                                        InputProps={{ style: { fontSize: 15, fontWeight: 'bold' } }}
                                    />
                                    <IconButton size="small" color='primary' onClick={handleTitleSave}>
                                        <DoneIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" color='error' onClick={() => {
                                        setIsEditingTitle(false);
                                        setTitle(previousTitle || "Untitled");
                                    }}>
                                        <ClearIcon fontSize="small" />
                                    </IconButton>
                                </Stack>
                            ) : (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                                    <Tooltip title={sessionId?.sessionId ? (title || "Untitled") : (defaultTitle || "Untitled")}>
                                        <Typography sx={{
                                            fontSize: 15,
                                            fontWeight: 'bold',
                                            color: '#333',
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            textOverflow: 'ellipsis',
                                            minWidth: 0,
                                        }}>
                                            {sessionId?.sessionId ? (title || "Untitled") : (defaultTitle || "Untitled")}
                                        </Typography>
                                    </Tooltip>
                                    {enableIconTitle && (
                                        <SvgIcon className="chat-icon" id="chat-icon" width="20" height="20" style={{ marginLeft: '4px', flexShrink: 0 }} />
                                    )}
                                    {sessionId?.sessionId && (
                                        <IconButton size='small' onClick={() => setIsEditingTitle(true)} sx={{ flexShrink: 0 }}>
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            )}
                        </Box>

                       

                        {/* Actions area — flexShrink: 0 so it only takes what it needs */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0, justifyContent: 'flex-end' }}>
                            {modelSwitcherSlot && (
                                <Box sx={{ minWidth: '100px', maxWidth: '140px', mx: '2px' }}>
                                    {modelSwitcherSlot}
                                </Box>
                            )}
                            {/* Patient Details button */}
                            {isPatientDetailsVisible && isFHIRConfigured && (
                                <IconButton
                                    size='small'
                                    sx={{
                                        width: '32px', height: '32px', minWidth: '32px',
                                        border: '1px solid #ccc', borderRadius: '4px',
                                        color: '#666', backgroundColor: 'transparent',
                                        '&:hover': { backgroundColor: '#f5f5f5', borderColor: '#999' },
                                    }}
                                    title={'Patient Details'}
                                    onClick={() => { setPatientDetailsOpen(true); }}
                                >
                                    <MedicalInformationIcon />
                                </IconButton>
                            )}
                            {/* New Chat / Clear filters button (Delete icon) */}
                            {newChatbutton?.enable && (
                                <Tooltip title={newChatbutton?.text || 'New Chat'}>
                                    <IconButton
                                        size="small"
                                        sx={{
                                            width: '32px', height: '32px', minWidth: '32px',
                                            border: '1px solid #ccc', borderRadius: '4px',
                                            color: '#666', backgroundColor: 'transparent',
                                            '&:hover': { backgroundColor: '#f5f5f5', borderColor: '#999' },
                                        }}
                                        onClick={handleNewChat}
                                    >
                                        {(newChatbutton?.text || 'New Chat').toLowerCase().includes('clear') ? (
                                            <DeleteIcon sx={{ fontSize: 18 }} />
                                        ) : (
                                            <AddCircleRoundedIcon sx={{ fontSize: 18 }} />
                                        )}
                                    </IconButton>
                                </Tooltip>
                            )}

                            

                            

                            {/* Expand / Close icon buttons (headerActions) */}
                            {headerActions}

                            {/* Model Switcher — stretches to fill middle space */}
                            
                        </Box>

                    </Box>


                    {/* Bottom row - Progress bar + Patient Details button */}
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        padding: '6px 16px 10px 16px',
                    }}>
                        {/* Progress bar */}
                        <Box sx={{ flex: 1, mr: 2 }}>
                            { !monthlyLimitsPending && aiLimits && lastRemainingPercentageRef.current < 20 && <ProgressBar 
                                className={color === 'danger' ? 'progress-min-width font-weight-600' : ''} 
                                style={{ height: '20px',maxWidth:'130px' }} 
                                label={`${lastRemainingPercentageRef.current}%`} 
                                variant={color} 
                                now={lastRemainingPercentageRef.current} 
                            />}
                            
                        </Box>
                       
                    </Box>
                </Box>
                
                {/* Chat content */}
                <Box sx={{ flex: 1, overflow: 'hidden' }}>
                    <AiChat 
                        selected={selected} 
                        height="100%" 
                        title={title} 
                        setTitle={setTitle} 
                        messages={messages} 
                        setMessages={setMessages} 
                        sessionId={sessionId} 
                        setSessionId={setSessionId} 
                        CHAT_TYPE={CHAT_TYPE} 
                        claimNumber={claimNumber} 
                        setPreviousTitle={setPreviousTitle} 
                        reloadChat={reloadChat} 
                        isEditingTitle={isEditingTitle} 
                        newMessageBtnRef={newMessageBtnRef} 
                        chatBotContainer={chatBotContainer} 
                        currentTypedUserMessage={currentTypedUserMessage} 
                        setCurrentTypedUserMessage={setCurrentTypedUserMessage} 
                        credits={aiLimits} 
                        isFetchingCredits={monthlyLimitsPending} 
                        setRefetchCredits={setRefetchCredits}
                        selectedClaimIds={selectedClaimIds}
                        totalClaimsCount={totalClaimsCount}
                        externalMessage={externalMessage}
                        onMessageSent={onMessageSent}
                        onFiltersUpdate={onFiltersUpdate}
                        disableAutoFocus={true}
                        isSidebarMode={isSidebarMode}
                        enableResponseFilters={enableResponseFilters}
                        newChatbutton={newChatbutton}
                        enableIconTitle={enableIconTitle}
                        queryContractId={queryContractId}
                        querySessionId={querySessionId}
                        enableFeedback={enableFeedback}
                        preAiModeFilters={preAiModeFilters}
                        significanceFlag={significanceFlag}
                        confidenceScoreFlag={confidenceScoreFlag}
                        reasoningModel={reasoningModel}
                        quickModel={quickModel}
                        availableModels={availableModels}
                    />
                </Box>
                {isPatientDetailsVisible?
                <PatientDetail claimId={queryContractId} isOpen={isPatientDetailsOpen} handleClose={()=>setPatientDetailsOpen(false)} isFhirConfigured={isFHIRConfigured} />:<></>}
            </Box>
        );
    }

    return (
        <>
            {!selected  && CHAT_TYPE !== 'claim' && <ContractsBreadCrumb root="/cms/contracts" directoryId={directoryId} />}
            <Helmet title="Contracts" />
            <Portlet>
                <PortletHeader
                    icon={<ChatIcon />}
                    center={
                        <div>
                            {
                                lastRemainingPercentageRef.current <= 20 && (<ProgressBar className={color === 'danger' && 'progress-min-width font-weight-600'} style={{ minWidth: '150px', display:'none' }} label={`${lastRemainingPercentageRef.current}%`} variant={color} now={lastRemainingPercentageRef.current} ref={usagePercentage} />
)
                            }
                            
                        </div>
                    }
                    titleComponent={
                        isEditingTitle ? (
                            <Stack direction="row" alignItems="center" gap={1}>
                                <TextField
                                    value={(!title && !isEditingTitle) ? "Untitled" : title}
                                    onChange={e => setTitle(e.target.value)}
                                    onKeyDown={e => {
                                        if (e.key === "Enter" && title) {
                                            handleTitleSave();
                                        } else if (e.key === "Escape") {
                                            setIsEditingTitle(false);
                                            setTitle(previousTitle || "Untitled");
                                        }
                                    }}
                                    autoFocus
                                    size="small"
                                    variant="standard"
                                    InputProps={{
                                        style: {
                                            fontSize: 16,
                                            fontWeight: 'bold',
                                            margin: "auto 0 auto 0"
                                        }
                                    }}
                                />
                                <Stack direction="row" alignItems="center">
                                    <IconButton color='primary' onClick={handleTitleSave}>
                                        <DoneIcon />
                                    </IconButton>
                                    <IconButton color='error' onClick={() => {
                                        setIsEditingTitle(false);
                                        setTitle(previousTitle || "Untitled");
                                    }}>
                                        <ClearIcon />
                                    </IconButton>
                                </Stack>
                            </Stack>

                        ) : (
                            <div
                                style={{
                                    // cursor: "pointer",
                                    fontSize: 16,
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    flex: 1,
                                    minWidth: 0,
                                    overflow: "hidden",
                                }}
                            >
                                <Tooltip title={sessionId?.sessionId ? (title || "Untitled") : (defaultTitle || "Untitled")}>
                                    <span style={{
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        minWidth: 0
                                    }}>
                                        {sessionId?.sessionId ? (title || "Untitled") : (defaultTitle || "Untitled")}
                                    </span>
                                </Tooltip>
                                {enableIconTitle && (
                                    <SvgIcon className="chat-icon" id="chat-icon" width="20" height="20" style={{ marginLeft: '4px', flexShrink: 0 }} />
                                )}
                                {
                                    sessionId?.sessionId && (<IconButton
                                    size='small'
                                    // color='primary'
                                    onClick={() => setIsEditingTitle(true)}
                                >
                                    <EditIcon />
                                </IconButton>)
                                }
                                
                            </div>
                        )
                    }
                    showTitle
                    toolbar={
                        <PortletHeaderToolbar>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                {modelSwitcherSlot && (
                                    <Box sx={{ minWidth: '100px', maxWidth: '140px' }}>
                                        {modelSwitcherSlot}
                                    </Box>
                                )}
                                {newChatbutton?.enable && (
                                    <Tooltip title={newChatbutton?.text || 'New Chat'}>
                                        <IconButton 
                                            size="small"
                                            sx={{
                                                width: '32px',
                                                height: '32px',
                                                minWidth: '32px',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                color: '#666',
                                                backgroundColor: 'transparent',
                                                '&:hover': {
                                                    backgroundColor: '#f5f5f5',
                                                    borderColor: '#999',
                                                },
                                            }}
                                            onClick={() => {
                                                setMessages([]);
                                                setSessionId({});
                                                setTitle(null);
                                                setPreviousTitle(null);
                                                setReloadChat(new Date().getTime())
                                                setCurrentTypedUserMessage("");
                                                setFollowUpQuestions([]);

                                                // Call onClearAllFilters callback if this is a "Clear all filters" button
                                                if (onClearAllFilters && (newChatbutton?.text || 'New Chat').toLowerCase().includes('clear')) {
                                                    onClearAllFilters();
                                                }

                                                // in scroll-to-bottom-button add style of display none to remove the button

                                                const container = chatBotContainer.current.closest(
                                                    ".chatbot-container-scrollbar"
                                                );
                                                if (container) {
                                                    container.scrollTop = container.scrollHeight;
                                                }
                                                if (newMessageBtnRef.current) {
                                                    newMessageBtnRef.current.style.display = "none";
                                                } 
                                            }}
                                        >
                                            {(newChatbutton?.text || 'New Chat').toLowerCase().includes('clear') ? (
                                                <DeleteIcon sx={{ fontSize: 18 }} />
                                            ) : (
                                                <AddCircleRoundedIcon sx={{ fontSize: 18 }} />
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                )}
                                <Button variant="outlined" color="primary"
                                    onClick={() => {
                                        if(selected?.length>0) {
                                            onClose()
                                            return
                                        }
                                        // Handle close action
                                        history.back();
                                    }}
                                >
                                    Close
                                </Button>
                            </Stack>
                        </PortletHeaderToolbar> 
                    }
                />

                <PortletBody>
                    <AiChat selected={selected} height={height || "100%"} title={title} setTitle={setTitle} messages={messages} setMessages={setMessages} sessionId={sessionId} setSessionId={setSessionId} CHAT_TYPE={CHAT_TYPE} claimNumber={claimNumber} setPreviousTitle={setPreviousTitle} reloadChat={reloadChat} isEditingTitle={isEditingTitle} newMessageBtnRef={newMessageBtnRef} chatBotContainer={chatBotContainer} currentTypedUserMessage={currentTypedUserMessage} setCurrentTypedUserMessage={setCurrentTypedUserMessage} credits={aiLimits} isFetchingCredits={monthlyLimitsPending} setRefetchCredits={setRefetchCredits} enableResponseFilters={enableResponseFilters} newChatbutton={newChatbutton} enableIconTitle={enableIconTitle} queryContractId={queryContractId} querySessionId={querySessionId} preAiModeFilters={preAiModeFilters} enableFeedback={enableFeedback} reasoningModel={reasoningModel} quickModel={quickModel} availableModels={availableModels}/>
                </PortletBody>
            </Portlet>
        </>
    );
};